import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";
import { ToastContainer } from "react-toastify";
import { Layout } from "antd";
import "react-toastify/dist/ReactToastify.css";

import MainFooter from "../components/layout/MainFooter";
const { Content } = Layout;
const SettingsLayout = ({ children, noNavbar, noFooter }) => (
  <Layout>
    <Container className="layout" fluid>
      <ToastContainer />
      <Row>
        <Col
          className="main-content p-0 m-0"
          lg={{ size: 12 }}
          md={{ size: 12 }}
          sm="12"
          tag="main"
        >
          <Content style={{ padding: "0 50px" }}>
            <Row lg={{ size: 12 }} md={{ size: 12 }} sm="12">
              <Col lg={{ size: 6 }} md={{ size: 6 }} sm="6"></Col>
              <Col
                lg={{ size: 6 }}
                md={{ size: 6 }}
                sm="6"
                style={{ margin: "16px 0" }}
                align="right"
              >
                <Link
                  to="/"
                  onClick={() => {
                    localStorage.removeItem("user");
                    localStorage.removeItem("user-auth");
                    localStorage.removeItem("role");
                  }}
                  className="text-light"
                  style={{ textDecoration: "none" }}
                >
                  <i className="material-icons">lock</i> Lock out
                </Link>
              </Col>
            </Row>
            <Col
              className="main-content p-0"
              lg={{ size: 12 }}
              md={{ size: 12 }}
              sm="12"
              tag="main"
            >
              {children}
            </Col>
          </Content>
        </Col>
      </Row>
      <Row>
        <Col
          className="main-content p-0"
          lg={{ size: 12 }}
          md={{ size: 12 }}
          sm="12"
          tag="main"
        >
          {!noFooter && <MainFooter />}
        </Col>
      </Row>
    </Container>
  </Layout>
);

SettingsLayout.propTypes = {
  noNavbar: PropTypes.bool,
  noFooter: PropTypes.bool,
};

SettingsLayout.defaultProps = {
  noNavbar: false,
  noFooter: false,
};

export default SettingsLayout;
